import axios from 'axios';
import constants from '../const.js';

const BASE = constants.DATA1_API_URL;
const authHeader = () => ({ Authorization: localStorage.getItem('token') });

export const enrollBiometricPrint = (actorId, type, file, label, sceneId) => {
    const form = new FormData();
    form.append('file', file);
    if (label) form.append('label', label);
    if (sceneId) form.append('scene_id', sceneId);
    return axios.post(`${BASE}/actor/${actorId}/biometrics/${type}`, form, {
        headers: authHeader(),
    });
};

export const listBiometricPrints = (actorId) =>
    axios.get(`${BASE}/actor/${actorId}/biometrics`, { headers: authHeader() });

export const deleteBiometricPrint = (actorId, printId) =>
    axios.delete(`${BASE}/actor/${actorId}/biometrics/${printId}`, { headers: authHeader() });

export const recognizeImage = (file, type = 'combined', threshold = 0.45) => {
    const form = new FormData();
    form.append('file', file);
    form.append('type', type);
    form.append('threshold', String(threshold));
    return axios.post(`${BASE}/recognize/image`, form, { headers: authHeader() });
};
